module.exports = __webpack_public_path__ + "img/search-header.4e5dffd8.png";